// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Gg3F","footer":"ModalCreateQualiphyProcedure_footer__2Fw2w","additionData":"ModalCreateQualiphyProcedure_additionData__2TzzT"};